import ProductFile from "./product-file";
import ProductFileAudio from "./product-file-audio";


export const productUploadTypes = {
    file : ProductFile,
    audio : ProductFileAudio
}
